import { ConfiguracaoAuthorizacaoModel } from "./configuracao-authorizacao-model";

export class ConfiguracoesModel {
    constructor(
        public configuracaoAuthorizacao: ConfiguracaoAuthorizacaoModel[] = [],
    ) { }
}